import { useEffect, useRef } from "react";

export function useCheckIfMounted() {
  const isMounted = useRef(true);
  useEffect(
    () => () => {
      isMounted.current = false;
    },
    []
  );
  return isMounted.current;
}
